import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { headCells } from 'pages/groups/data';

const UserTableHead = () => (
  <TableHead style={{ backgroundColor: '#000' }}>
    <TableRow>
      {headCells.map((headCell) => (
        <TableCell align='center' key={headCell.id} style={{ color: 'white' }}>
          {headCell.label}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);

export default UserTableHead;
